import {
  FETCH_ALL_FUNCTIONS_SUCCESS,
  FETCH_FUNCTION_BY_ID_REQUEST,
  FETCH_FUNCTION_BY_ID_ERROR,
  FETCH_FUNCTION_BY_ID_SUCCESS,
  FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS,
} from "../../actions";

import { FunctionsByIdSTORE } from "../types";
import { FunctionsActions } from "../../actionCreators";

import idReducer from "./id";

const initialState: FunctionsByIdSTORE = {};

const byIdReducer = (
  state = initialState,
  action: FunctionsActions
): FunctionsByIdSTORE => {
  switch (action.type) {
    case FETCH_ALL_FUNCTIONS_SUCCESS:
      return action.payload.functions.reduce(
        (acc: FunctionsByIdSTORE, curr) => {
          acc[curr.id] = { ...curr, isFetching: false };
          return acc;
        },
        {}
      );

    case FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS:
      return action.payload.functions.reduce(
        (acc, curr) => {
          acc[curr.id] = { ...curr, isFetching: false };
          return acc;
        },
        { ...state }
      );

    case FETCH_FUNCTION_BY_ID_ERROR:
    case FETCH_FUNCTION_BY_ID_REQUEST:
    case FETCH_FUNCTION_BY_ID_SUCCESS:
      // tenhle lint problem zmizí s ts immer
      // eslint-disable-next-line
      const { id } = action.payload;

      return {
        ...state,
        [id]: idReducer(state[id], action),
      };

    default:
      return state;
  }
};

export default byIdReducer;
